function watchAndSyncHeader() {
  const heading = document.querySelector('#collection-page-title');
  const typeSelect = document.getElementById('equipment-type');
  const makeSelect = document.getElementById('make');
  
  if (!heading) return;

  if (!typeSelect && !makeSelect) {
    heading.style.visibility = 'visible';
    return;
  }

  let isPendingSearch = false;

  function updateTitle() {
    // If a human changed the dropdown, show the reminder instead of the track name
    if (isPendingSearch) {
      heading.textContent = "Click 'Search' to refresh selection";
      heading.style.visibility = 'visible';
      return;
    }

    let typeText = '';
    let makeText = '';

    if (typeSelect && typeSelect.value && typeSelect.selectedIndex > 0) {
      typeText = typeSelect.options[typeSelect.selectedIndex].text;
    }

    if (makeSelect && makeSelect.value && !makeSelect.classList.contains('loading') && makeSelect.selectedIndex > 0) {
      makeText = makeSelect.options[makeSelect.selectedIndex].text;
    }

    if (typeText || makeText) {
      const parts = ['Tracks for', makeText, typeText].filter(Boolean);
      heading.textContent = parts.join(' ');
    }
    
    heading.style.visibility = 'visible';
  }

  // e.isTrusted ensures this ONLY triggers when a human clicks, not when the page loads
  if (typeSelect) {
    typeSelect.addEventListener('change', (e) => { 
      if (e.isTrusted) { isPendingSearch = true; updateTitle(); }
    });
  }
  if (makeSelect) {
    makeSelect.addEventListener('change', (e) => { 
      if (e.isTrusted) { isPendingSearch = true; updateTitle(); }
    });
  }

  let checks = 0;
  const loadInterval = setInterval(() => {
    if (!isPendingSearch) updateTitle();
    checks++;
    if (checks > 20) clearInterval(loadInterval); 
  }, 250);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.startsWith('/collections')) {
    watchAndSyncHeader();
  }
});